/**
 * @generated SignedSource<<b80383187c3fea566811aaad010a158c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type plusWebinarWidgetContentItemContent$data = {
  readonly __typename: string;
  readonly " $fragmentSpreads": FragmentRefs<"hooksContentItemProvidersContent">;
  readonly " $fragmentType": "plusWebinarWidgetContentItemContent";
};
export type plusWebinarWidgetContentItemContent$key = {
  readonly " $data"?: plusWebinarWidgetContentItemContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"plusWebinarWidgetContentItemContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "plusWebinarWidgetContentItemContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "withCoverImage",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "withCoverImageSize540x360",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "withHeadline",
          "value": true
        }
      ],
      "kind": "FragmentSpread",
      "name": "hooksContentItemProvidersContent"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "470f814cf9a2fa8d98d4e65292fb1de5";

export default node;
